import { EventContentArg } from '@fullcalendar/react';
import { upperCase } from 'lodash';
import React, { useState } from 'react';
import { CALENDAR_VIEW, ExtendedProps } from '../types';
import './event.css';
import chroma from 'chroma-js';
import { getEventBackgroundColor } from '../helpers';

interface EventProps {
  width: number;
  view: CALENDAR_VIEW;
  eventContent: EventContentArg;
  active?: boolean;
}

const Event: React.FC<EventProps> = ({
  eventContent,
  width,
  view,
  active = false,
}) => {
  const event = eventContent.event;
  const extendedProps = event.extendedProps as ExtendedProps;
  const eventBackgroundColor = getEventBackgroundColor(extendedProps?.color);
  return (
    <div className="w-full h-full flex">
      {view === 'dayGridMonth' && width !== 1
        ? monthView()
        : width === 1
        ? normalView()
        : // ? width1View()
          normalView()}
    </div>
  );

  function monthView() {
    return (
      <div
        style={{ background: eventBackgroundColor }}
        className="w-full rounded-md text-xs text-black font-medium py-px px-2"
      >
        <div className="flex truncate">{extendedProps.description}</div>
      </div>
    );
  }

  function width1View() {
    return (
      <div className="flex justify-center pl-1 ">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Bitcoin.svg/1200px-Bitcoin.svg.png"
          alt="logo"
          className="w-5 h-5 object-cover rounded-full"
        />
      </div>
    );
  }

  function normalView() {
    return (
      <div
        className="rounded-xl flex-1 items-center px-1 h-full flex gap-2 cursor-pointer bg-primary w-full"
        style={{
          background: eventBackgroundColor,
          border: active
            ? `1px solid ${chroma(extendedProps.color).darken().hex()}`
            : '1px solid transparent',
        }}
      >
        <div className="truncate">
          <p className="text-xs text-grey-70">
            {upperCase(extendedProps.organizationName)}
          </p>
          <p className="text-xs text-black font-medium">
            {extendedProps.description}
          </p>
        </div>
      </div>
    );
  }
};

export default Event;
